// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5536) return "static/chunks/5536-d40dec3272c16f36.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"3496":"graphql-print","4254":"56c12eb5","5970":"lottie"}[chunkId] || chunkId) + "." + {"3496":"7ef39872c8b54dd4","4254":"cfaf0f642ce9413b","5970":"30568860e6b3fcc4","6152":"3cca1108cd40f9ac","7878":"58b042096239157c"}[chunkId] + ".js";
};